import React, { useEffect } from 'react';
import type { EditConfigCopyright } from '@types';
import useTourEditing from '@hooks/useTourEditing';
import Title from '@components/Title';
import { Collapse } from '@components/Collapse';
import Input from '@components/Input';
import Textarea from '@components/Textarea';
import Tip from '@components/Tip';
import useLangString from '@hooks/useLangString';
import { $editingCopyright } from '@stores/editingStores';
import PanelBase from '../PanelBase';
import type { PanelBaseProps } from '../types';

function CopyrightBase({
  defaultValue,
  onConfirm,
}: PanelBaseProps<EditConfigCopyright>) {
  const { state, setState, isChanged } = useTourEditing(defaultValue, {
    content: '',
    title: '',
  });

  const lang = useLangString({ ph: ['免责声明', 'Disclaimer'] }, []);

  useEffect(() => {
    $editingCopyright.api.set(state);
    return () => {
      $editingCopyright.api.set(null);
    };
  }, [state]);

  return (
    <PanelBase
      isChanged={isChanged}
      title={<Title>免责声明</Title>}
      onConfirm={() => {
        onConfirm(state);
      }}
    >
      <Collapse title="标题设置">
        <Input
          scheme="dark"
          className="h-30"
          maxLength={50}
          placeholder={lang.ph}
          value={state.title}
          onChange={(e) =>
            setState((draft) => {
              draft.title = e.target.value;
            })
          }
          onClear={() => {
            setState((draft) => {
              draft.title = '';
            });
          }}
        />
      </Collapse>
      <Collapse title="内容设置">
        <Textarea
          scheme="dark"
          maxLength={10000}
          style={{ height: 400 }}
          placeholder="请填写声明内容"
          value={state.content}
          onChange={(e) =>
            setState((draft) => {
              draft.content = e.target.value;
            })
          }
        />
        <Tip className="mt-20">
          非必填，填写后在漫游播放页会显示出免责声明按钮及声明内容
        </Tip>
      </Collapse>
    </PanelBase>
  );
}

export default CopyrightBase;
